import '../App.css';
import Licenses from './Licenses';

function App() {
  return (<Licenses/>);
}

export default App;
